import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export type FeatureKey = "indicadores" | "sociedade" | "gerador" | "fluxos" | "ia_resumo" | "sharepoint" | "assinatura" | "whatsapp" | "conector_tribunais" | "api_publica";
export interface FeaturesResponse { values: Record<FeatureKey, boolean>; catalog: Array<{ key: FeatureKey; label: string; default: boolean }> }

/** Funções liberadas para o escritório (Configurações › Funções e API). Enquanto carrega, tudo que é padrão aparece. */
export function useFeatures(): { on: (k: FeatureKey) => boolean; data?: FeaturesResponse } {
  const { data } = useQuery({ queryKey: ["recursos"], queryFn: () => api.get<FeaturesResponse>("/recursos"), staleTime: 5 * 60_000 });
  const defaults: Partial<Record<FeatureKey, boolean>> = { assinatura: false, whatsapp: false, conector_tribunais: false, api_publica: false };
  return { data, on: (k) => (data ? data.values[k] !== false : defaults[k] !== false) };
}
